import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import type { UserRole } from "../data/types";
import { useAuth } from "../context/AuthContext";

export function RoleRoute({ allow, children }: { allow: UserRole[]; children: ReactNode }) {
  const { user } = useAuth();
  const userRole = user?.role?.toLowerCase() as UserRole | undefined;
  const allowLower = allow.map(r => r.toLowerCase()) as UserRole[];
  if (!user || !userRole || !allowLower.includes(userRole)) {
    return <Navigate to="/admin/forbidden" replace />;
  }
  return <>{children}</>;
}
